import CreativeBriefs from './CreativeBriefs.Container';

export default CreativeBriefs;
